module.exports = __webpack_public_path__ + "img/es-pc-s4.0691d8dd.png";